import {
  MEDIA_PREVIEW,
  MEDIA_NEW,
  MEDIA_UPDATE,
  MEDIA_REMOVE,
  MEDIA_PROCESS_SUCCESS,
  MEDIA_DATASOURCE_SUCCESS,
  MEDIA_SEARCH,
  MEDIA_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case MEDIA_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case MEDIA_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case MEDIA_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case MEDIA_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case MEDIA_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case MEDIA_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case MEDIA_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case MEDIA_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}